import axios from "axios";

// Módulo "Paquetes y precios". {tipo} = curso | alquiler | servicio-externo
const RUTA_ITEM = {
  curso: "/api/curso",
  alquiler: "/api/alquiler",
  "servicio-externo": "/api/servicioexterno",
};

const state = {
  categorias: [],
  cursos: [],
  alquileres: [],
  servicios: [],
};

const mutations = {
  SET_CATALOGO(state, data) {
    state.categorias = data.categorias;
    state.cursos = data.cursos;
    state.alquileres = data.alquileres;
    state.servicios = data.servicios;
  },
};

const actions = {
  async fetchCatalogo({ commit }) {
    const { data } = await axios.get("/api/paquetes-precios");
    commit("SET_CATALOGO", data);
    return data;
  },
  async guardarItem({ dispatch }, { tipo, item }) {
    const { id, ...payload } = item;
    if (id) {
      await axios.put(`${RUTA_ITEM[tipo]}/${id}`, payload);
    } else {
      await axios.post(RUTA_ITEM[tipo], payload);
    }
    return dispatch("fetchCatalogo");
  },
  async cambiarEstadoItem({ dispatch }, { tipo, id, estado }) {
    await axios.put(`${RUTA_ITEM[tipo]}/${id}`, { estado });
    return dispatch("fetchCatalogo");
  },
  async agregarPrecio({ dispatch }, { tipo, itemId, precio }) {
    await axios.post(`/api/paquetes-precios/${tipo}/${itemId}`, precio);
    return dispatch("fetchCatalogo");
  },
  async actualizarPrecio({ dispatch }, { tipo, precioId, precio }) {
    await axios.put(`/api/paquetes-precios/${tipo}/precio/${precioId}`, precio);
    return dispatch("fetchCatalogo");
  },
  async cambiarEstadoPrecio({ dispatch }, { tipo, precioId, activo }) {
    await axios.patch(`/api/paquetes-precios/${tipo}/precio/${precioId}/estado`, { activo });
    return dispatch("fetchCatalogo");
  },
};

const getters = {
  categorias: (state) => state.categorias,
  cursos: (state) => state.cursos,
  alquileres: (state) => state.alquileres,
  servicios: (state) => state.servicios,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
